import {ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {ActiveCartService} from '@spartacus/cart/base/core';
import {CmsComponent, CmsService} from '@spartacus/core';
import {switchMap, takeWhile, tap} from 'rxjs/operators';
import {DcpCartDecoratorService} from '@app/services/dcp-cart-decorator.service';
import {JsonService} from '@dcp/configurator';
import {OrderEntry} from '@spartacus/cart/base/root/models/cart.model';
import {TransactionTypeCode} from '@app/services/transactionTypes/transaction-type-code';

export interface NavigationToComponentData extends CmsComponent {
  classificationsProductData: string;
}

export class NavigationToCmsData {
  title: string;
}

@UntilDestroy()
@Component({
  selector: 'dcp-navigation-to',
  templateUrl: './navigation-to.component.html',
})
export class NavigationToComponent implements OnInit {

  componentData: NavigationToCmsData;
  transactionTypes: string[];
  canShow: boolean = false;

  @Input() url: string = '/checkout/data-entry';
  @Input() showArrow: boolean = true;

  constructor(private cmsService: CmsService,
              private jsonService: JsonService,
              protected activeCartService: ActiveCartService,
              private dcpCartDecoratorService: DcpCartDecoratorService,
              private cdr: ChangeDetectorRef,
  ) {
  }

  ngOnInit() {
    let placeOrderStarted = false;
    this.dcpCartDecoratorService.isPlaceOrderPending$.pipe(
      tap((isPending: boolean) => placeOrderStarted ||= isPending),
      switchMap(() => this.activeCartService.getEntries()),
      takeWhile(() => !placeOrderStarted),
      untilDestroyed(this)
    ).subscribe(entries => {
      this.canShow = this.showNavigationComponent(entries.map((entry: OrderEntry) => entry.transactionType));
    });
    this.getNavigationToCmsData();
  }

  getNavigationToCmsData(): void {
    this.cmsService.getComponentData('NavigationToComponent')
      .pipe(untilDestroyed(this))
      .subscribe((data: NavigationToComponentData) => {
        this.componentData = this.jsonService.parseSafely(data?.classificationsProductData) as NavigationToCmsData;
        this.cdr.detectChanges();
      });
  }

  showNavigationComponent(types: any[]) {
    return !types?.includes(TransactionTypeCode.ORDER_UPSELL);
  }
}
